import RenderResources from "../RenderResources.vue";
export { RenderResources };
